import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../Redux/hooks/useAuth'
import Footer from '../Layouts/Footer'
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

export function PrivateOutlet() {
  const auth = useAuth()
  const location = useLocation()

  return auth.user ? (
    <div className={!location.pathname.startsWith('/edit') ? "container-lg" : ""}>
        <Outlet />
        <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
        />
        {!location.pathname.startsWith('/edit') && <Footer />}
    </div>
  ) : (
    <Navigate to="/login" state={{ from: location }} />
  )
}
